import React, { useState, useEffect, useRef } from "react"
import FullCalendar from "@fullcalendar/react" // must go before plugins
import dayGridPlugin from "@fullcalendar/daygrid" // a plugin!
import timeGridPlugin from "@fullcalendar/timegrid"
import listPlugin from "@fullcalendar/list"
import interactionPlugin from "@fullcalendar/interaction"
import deLocale from "@fullcalendar/core/locales/de"
import moment from "moment"

import { collectionFullSlugPrefixer } from "../../helper/collectionFullSlugPrefixer"
import EventService from "../../services/event"

const MCalendarOverview = (props) => {
  const [eventItems, setEventItems] = useState(null)
  const [filterableCategories, setFilterableCategories] = useState([])
  const eventServiceObj = new EventService()
  const loadEvents = async (categories, without_category) => {
    let resp = await eventServiceObj.getEvents(categories, without_category)
    if (!categories && resp.root_categories) {
      setFilterableCategories(eventServiceObj.filterableCategories)
      setEventItems(
        transformEventObjects(
          resp.results,
          eventServiceObj.filterableCategories
        )
      )
    } else {
      setEventItems(transformEventObjects(resp.results, filterableCategories))
    }
  }
  const categoryFilterRef = useRef(null)
  const [renderCalendar, setRenderCalendar] = useState(false)

  const transformEventObjects = (events, categories) => {
    events = collectionFullSlugPrefixer(events)
    return events.map((eventPage) => {
      let startDate = moment(eventPage.eventdata.start).format(
        "YYYY-MM-DDTHH:mm:ss"
      )
      let endDate = moment(eventPage.eventdata.end).format(
        "YYYY-MM-DDTHH:mm:ss"
      )
      if (moment(eventPage.eventdata.end).format("H") === "0") {
        endDate = moment(eventPage.eventdata.end)
          .add(1, "days")
          .format("YYYY-MM-DDTHH:mm:ss")
      }
      return {
        title: eventPage.name,
        start: startDate,
        end: endDate,
        allDay:
          moment(eventPage.eventdata.start).format("H") === "0" ? true : false,
        color: getColorForEvent(eventPage, categories),
        textColor: "#1e1e1e",
        extendedProps: {
          full_slug: eventPage.full_slug,
        },
      }
    })
  }

  const getColorForEvent = (event, categories) => {
    if (
      !event.content.root_categories ||
      event.content.root_categories.length === 0
    ) {
      return categories[categories.length - 1].color
    } else {
      return getColorForCategory(event.content.root_categories[0], categories)
    }
  }

  const getColorForCategory = (category, categories) => {
    if (category && category.uid) {
      return categories.find((cat) => {
        return cat.uid === category.uid
      })?.color
    } else {
      return categories[categories.length - 1].color
    }
  }

  const handleFilter = async () => {
    const activeCategories = categoryFilterRef.current.querySelectorAll(
      "input:checked[name=category]"
    )
    let category_ids = []
    let without_category = false

    Array.from(activeCategories).forEach((input) => {
      if (input.value === "0") {
        without_category = true
      } else {
        category_ids.push(input.value)
      }
    })

    await loadEvents(category_ids.join(","), without_category)
  }

  useEffect(() => {
    // set
    loadEvents()

    const delayCalendar = setTimeout(() => {
      setRenderCalendar(true)
    }, 1000)

    return () => {
      if (delayCalendar) {
        clearTimeout(delayCalendar)
      }
    }
  }, [])

  const handleEventClick = (args) => {
    if (args.event?.extendedProps?.full_slug) {
      document.location.href = args.event?.extendedProps?.full_slug
    }
  }

  return (
    <section className="m-Feed u-Spacing-l">
      <div className="m-Feed-wrapper">
        <div className="m-Feed-container">
          <div className="m-Feed-content">
            {filterableCategories && filterableCategories.length > 0 && (
              <div ref={categoryFilterRef}>
                {filterableCategories.map((cat) => {
                  return (
                    <div key={cat.uid} 
                      style={{
                        padding: "5px",
                      }}
                      className="dfb-Checkbox">
                      <label className="dfb-Checkbox-field">
                        <input
                          className="dfb-Checkbox-input"
                          type="checkbox"
                          value={cat.uid}
                          name="category"
                          onChange={handleFilter}
                        />
                        <span
                          style={{
                            backgroundColor: cat.color,
                            padding: "0 3px",
                          }}
                          className="dfb-Checkbox-box"
                          aria-hidden="true"
                        ></span>
                        <span
                          className="dfb-Checkbox-label"
                        >
                          {cat.title}
                        </span>
                      </label>
                    </div>
                  )
                })}
                <br />
              </div>
            )}

            {eventItems && (
              <>
                {props.data &&
                props.data.title &&
                props.data.title.indexOf("grid") !== -1 ? (
                  <FullCalendar
                    locales={[deLocale]}
                    plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
                    timeZone="local"
                    headerToolbar={{
                      left: "prev,next today",
                      center: "title",
                      right: "dayGridMonth,timeGridWeek,timeGridDay",
                    }}
                    initialView="dayGridMonth"
                    locale="de"
                    weekNumbers={true}
                    aspectRatio={2}
                    weekNumberCalculation="ISO"
                    eventLimit={true}
                    eventClick={(args) => {
                      handleEventClick(args)
                    }}
                    dayMaxEventRows={true}
                    views={{
                      timeGrid: {
                        dayMaxEventRows: 2,
                      },
                    }}
                    events={eventItems}
                  />
                ) : (
                  <FullCalendar
                    locales={[deLocale]}
                    plugins={[listPlugin, interactionPlugin]}
                    timeZone="local"
                    headerToolbar={{
                      left: "prev,next",
                      center: "title",
                      right: "listMonth,listYear",
                    }}
                    initialView="listMonth"
                    locale="de"
                    height="auto"
                    contentHeight="auto"
                    eventClick={(args) => {
                      handleEventClick(args)
                    }}
                    views={{
                      listMonth: { buttonText: "MONAT" },
                      listYear: { buttonText: "JAHR" },
                    }}
                    events={eventItems}
                  />
                )}
              </>
            )}
          </div>
        </div>
      </div>
    </section>
  )
}

export default MCalendarOverview
